import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { User, Lock, Eye, EyeOff } from 'lucide-react';
import LogoForm from '../assets/images/logo-form-branca.png';
import LogoFundo from '../assets/images/fundo1.jpg';
import LogoFarmacia from '../assets/images/logo_farmacia.png';

const Login = () => {
  const { token, login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    senha: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Se já estiver logado, redirecionar para dashboard
  if (token) {
    return <Navigate to="/" />;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Limpar erro quando o usuário começar a digitar
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.nome, formData.senha);
    
    if (result.success) {
      // Usar redirecionamento personalizado se fornecido
      navigate(result.redirectTo || '/');
    } else {
      setError(result.message);
    }
    
    setLoading(false);
  };

  return (
    <div id='login'
    style={{
      backgroundImage: `url(${LogoFundo})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '16% 32%',
      height: '100vh',
      overflow: 'hidden'
    }}>

      <header>
          <div className="logo">
            <img src={LogoForm} alt="Form Tecnologia"/>
          </div>
          <nav>
            <a href="https://www.formtecnologia.com.br/" className="destaque-mark">FORM TECNOLOGIA</a>
            <span id="divisao"></span>
            <a href="https://api.whatsapp.com/send?phone=5532999957432" className="destaque-mark">DÚVIDAS</a>
          </nav>
      </header>

      <main>
        <form 
          onSubmit={handleSubmit}
          className='formulario'
        >
          <div className="logo">
            <img src={LogoFarmacia} alt="Farmacia Popular De Minas" />
          </div>

          <div className="form-group">
            <label className="form-label">
              <User size={16} style={{ marginRight: '8px' }} />
              Nome de Usuário
            </label>
            <input
              type="text"
              name="nome"
              className="form-control"
              placeholder="Digite seu nome de usuário"
              value={formData.nome}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <Lock size={16} style={{ marginRight: '8px' }} />
              Senha
            </label>
            <div className="form-control" style={{ display: 'flex' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="senha"
                placeholder="Digite sua senha"
                value={formData.senha}
                onChange={handleChange}
                required
                disabled={loading}
                style={{ paddingRight: '45px', border: 'none' }}
              />
              <button
                type="button"
                style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', margin: '1rem 0rem', display: 'block', textAlign: 'center' }}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="spinner" style={{ width: '16px', height: '16px', margin: '0' }}></div>
                Entrando...
              </>
            ) : (
              'Entrar'
            )}
          </button>
        </form>

        <div className="info">
          <p>Sistema fornecido por</p>
          <p><strong>Form Tecnologia</strong></p>
          <p id="versao"><i>Versão 1.0.0</i></p>
        </div>

      </main>
    </div>
  );
};

export default Login;